import getLocaleFromUrl from '../utils/getLocaleFromUrl'

export default (lang) => (dispatch, getState) => {
  dispatch({type: 'preferences_change', field:'lang', value:lang})
  const oldLocale = getLocaleFromUrl()
  const newHash = location.hash.replace(`#/${oldLocale}`, lang)
  location.hash = newHash
}



/** WEBPACK FOOTER **
 ** ./app/actions/langChange.js
 **/